module.exports = __webpack_public_path__ + "static/media/dollar-symbol.d6d574a1.svg";